// @catalog F.006
// @catalog F.030
// AlertBanner — banner condicional para underperformers (/ventas) o
// productos con margen crítico (/margenes). Soporta severidad neg/warn.
import type { ReactNode } from "react";
import { Box } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface AlertBannerProps {
  severity?: "neg" | "warn";
  children: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
}

export function AlertBanner(props: AlertBannerProps): JSX.Element {
  const { severity = "neg", children, actionLabel, onAction } = props;

  const palette =
    severity === "neg"
      ? {
          bg: "var(--neg-soft)",
          color: "#7a1e15",
          border: "color-mix(in oklab, var(--neg) 25%, transparent)",
        }
      : {
          bg: "var(--warn-soft)",
          color: "#6e4400",
          border: "color-mix(in oklab, var(--warn) 25%, transparent)",
        };

  return (
    <Box
      role="alert"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px 14px",
        backgroundColor: palette.bg,
        border: `1px solid ${palette.border}`,
        borderRadius: "var(--radius)",
        fontSize: "13px",
        color: palette.color,
      }}
    >
      <WarningAmberIcon sx={{ fontSize: 16 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
      {actionLabel && onAction && (
        <Box
          component="button"
          type="button"
          onClick={onAction}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "6px 10px",
            borderRadius: "6px",
            color: "var(--ink-2)",
            fontSize: "13px",
            border: "1px solid var(--border)",
            backgroundColor: "var(--surface)",
            cursor: "pointer",
            fontFamily: "inherit",
            "&:hover": { backgroundColor: "var(--bg-2)" },
            "&:focus-visible": {
              outline: "2px solid var(--accent)",
              outlineOffset: "1px",
            },
          }}
        >
          {actionLabel}
          <ArrowForwardIcon sx={{ fontSize: 13 }} />
        </Box>
      )}
    </Box>
  );
}
